import { TableCalculate, ActionTypes, LOAN_CONSTANTS } from '../common';
import { calculateInstallmentSchedule, calculatePMTSchedule } from '../utils/loanCalculations';
import type { UnknownAction } from 'redux';

export type TableCalculateState = TableCalculate;

const initialState: TableCalculateState = {
  month: 60,
  borrowingPrice: 240000000,
  rows: [],
  precentBankBefore: LOAN_CONSTANTS.DEFAULT_INTEREST_RATE_FIRST_6_MONTHS,
  precentBankAfter: LOAN_CONSTANTS.DEFAULT_INTEREST_RATE_AFTER,
  discountMonths: LOAN_CONSTANTS.PROMOTIONAL_PERIOD_MONTHS,
  calculationType: 'declining',
};

interface CalculateActionPayload {
  type: typeof ActionTypes.CALCULATE;
  payload: Partial<TableCalculate>;
}

type TableCalculateAction = CalculateActionPayload | UnknownAction;

export const tableCalculateReducer = (
  state: TableCalculateState = initialState,
  action: TableCalculateAction
): TableCalculateState => {
  if (action.type === ActionTypes.CALCULATE) {
    const calculateAction = action as CalculateActionPayload;
    const data = { ...state, ...calculateAction.payload };

    if (data.calculationType === 'pmt') {
      data.rows = calculatePMTSchedule({
        borrowingPrice: data.borrowingPrice,
        month: data.month,
        annualRate: data.precentBankBefore,
      });
    } else {
      data.rows = calculateInstallmentSchedule({
        borrowingPrice: data.borrowingPrice,
        month: data.month,
        precentBankBefore: data.precentBankBefore,
        precentBankAfter: data.precentBankAfter,
        discountMonths: data.discountMonths,
      });
    }

    return data;
  }

  return state;
};
